var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgZa = function SvgZa(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21786_20668",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21786_20668)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10L3 3V0H20V10H9.5Z",
    fill: "#CD473B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10L3 17V20H20V10H9.5Z",
    fill: "#1936B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.900781 0.298828V3.49883L7.30078 9.49883L0.300781 16.6988L0.700781 19.4988L3.10078 19.6988L10.5008 12.0988L20.5008 12.2988L20.3008 7.29883H10.5008L3.70078 0.298828H0.900781Z",
    fill: "#347851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30078 9.69727L1.10078 4.09727V2.69727L7.90078 9.69727L1.10078 16.6973L0.300781 15.8973L6.30078 9.69727Z",
    fill: "#F4BA43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3008 11.6996L3.30078 18.8996L4.30078 19.0996L10.5008 12.6996H19.9008V11.6996H10.3008Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3008 7.89805L3.30078 0.698047L4.30078 0.498047L10.5008 6.89805H19.9008V7.89805H10.3008Z",
    fill: "#F6F8FA"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgZa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/za.19e343e0aa5243d6b6a4dde6d8dd20e4.svg";